import React from 'react'
import { Switch, Route, Redirect } from 'react-router'
import { LANGUAGES } from '../_i18n/languages';
import loadable from '@loadable/component'

// import About from '../about/About'
const Terms = loadable(() => import('../terms/Terms'))
const Privacy = loadable(() => import('../privacy/Privacy'))
const NotFound = loadable(() => import('../notFound/NotFound'))
const Stopwatch = loadable(() => import('../stopwatch/Stopwatch'))
const Timer = loadable(() => import('../timer/Timer'))
const PomodoroTimer = loadable(() => import('../pomodoroTimer/PomodoroTimer'))
const BombTimer = loadable(() => import('../bombTimer/BombTimer'))
const RocketTimer = loadable(() => import('../rocketTimer/RocketTimer'))
const DateCalculator = loadable(() => import('../dateCalculator/DateCalculator'))
const Clock = loadable(() => import('../clock/Clock'))
const Dino = loadable(() => import('../games/dino/Dino'))
const TicTacToe = loadable(() => import('../games/ticTacToe/TicTacToe'))
const CatTimer = loadable(() => import('../catTimer/CatTimer'))
const ChristmasTimer = loadable(() => import('../christmasTimer/ChristmasTimer'))
const CountDownNewYear = loadable(() => import('../countdown/CountdownNewYear'))
const MonsterRace = loadable(() => import('../monsterRace/MonsterRace'))
const RocketRace = loadable(() => import('../rocketRace/RocketRace'))
const RunningRace = loadable(() => import('../runningRace/RunningRace'))
const SwimmingRace = loadable(() => import('../swimmingRace/SwimmingRace'))
const DynamiteTimer = loadable(() => import('../dynamiteTimer/DynamiteTimer'))
const EggTimer = loadable(() => import('../eggTimer/EggTimer'))
const CandleTimer = loadable(() => import('../candleTimer/CandleTimer'))
const ExamTimer = loadable(() => import('../examTimer/ExamTimer'))
// eslint-disable-next-line no-unused-vars
const BouncyBallsTimer = loadable(() => import('../bouncyBalls/BouncyBallsTimer'))
const VisualTimer = loadable(() => import('../visualTimer/VisualTimer'))
const PacmanTimer = loadable(() => import('../pacmanTimer/PacmanTimer'))
const SnailRace = loadable(() => import('../animalRace/SnailRace'))
const DuckRace = loadable(() => import('../animalRace/DuckRace'))
const HorseRace = loadable(() => import('../animalRace/HorseRace'))
const MathBingo = loadable(() => import('../games/mathBingo/MathBingo'))
const AdventureRunner = loadable(() => import('../games/adventureRunner/AdventureRunner'))
const MathWizard = loadable(() => import('../games/mathWizard/MathWizard'))
const DigitalEscapeRoom = loadable(() => import('../games/digitalEscapeRoom/DigitalEscapeRoom'))
const StemGamification = loadable(() => import('../articles/StemGamification'))

const isValidPreset = (preset) => {
    if (!preset || preset === 'undefined') return false;
    const decoded = decodeURI(preset).toLowerCase();
    const parts = decoded.split('-');
    const len = parts.length;

    // Formatos válidos: N-unit-timer, N-unit-M-unit-timer ou N-unit-M-unit-O-unit-timer
    if (len !== 3 && len !== 5 && len !== 7) return false;
    if (parts[len - 1] !== 'timer') return false;

    const isNum = (n) => !isNaN(parseInt(n)) && parseInt(n) > 0;
    if (!isNum(parts[0])) return false;
    if (len >= 5 && !isNum(parts[2])) return false;
    if (len === 7 && !isNum(parts[4])) return false;

    return true;
};

const MultiLanguageRoute = (props) => {
    const { component: Component, path, ...rest } = props;
    const { lang: langParam, preset: presetParam } = props.computedMatch.params;
    
    // 1. Validar se o idioma fornecido na URL é suportado.
    if (langParam && !LANGUAGES[langParam]) {
        return <Route component={NotFound} />;
    }

    // 2. Validar o preset se existir (específico para countdown-timer)
    if (presetParam && !isValidPreset(presetParam)) {
        return <Route component={NotFound} />;
    }

    // 3. Validar a profundidade da URL (segmentos).
    const segments = props.location.pathname.split('/').filter(Boolean);
    const pathSegments = path.split('/').filter(Boolean);

    // Conta apenas os segmentos obrigatórios (aqueles que não possuem o sufixo ?)
    const requiredSegments = pathSegments.filter(s => !s.endsWith('?'));
    const expectedMin = requiredSegments.length;
    const expectedMax = pathSegments.length;

    if (segments.length < expectedMin || segments.length > expectedMax) {
        return <Route component={NotFound} />;
    }

    return <Route {...rest} path={path} render={(routeProps) => <Component {...routeProps} {...rest} />} />;
}

const router = (props) => (
    <React.Fragment>
        <Switch>
            <Route exact path='/' component={Stopwatch} />
            {/* <Route path='/about' component={About} /> */}
            <Route path='/terms' component={Terms} />
            <Route path='/privacy' component={Privacy} />
            {/* <Route path='/timers' render={(props) => <Home {...props} custom={{
                'title': '',
                'description': ''
            }} />} /> */}
            <MultiLanguageRoute path='/pomodoro-timer/:lang?' component={PomodoroTimer} />
            <MultiLanguageRoute path='/countdown-timer/:lang?/:preset?' {...props} component={Timer} />
            <MultiLanguageRoute path='/online-timer/:lang?' component={Timer} custom={{
                'title': 'timer.online-timer.seo.title',
                'description': 'timer.online-timer.seo.description',
                'h1': 'timer.online-timer.h1',
                'desc1': 'timer.online-timer.desc.1'
            }} />
            <MultiLanguageRoute path='/online-countdown/:lang?' component={Timer} custom={{
                'title': 'timer.online-countdown.seo.title',
                'description': 'timer.online-countdown.seo.description',
                'h1': 'timer.online-countdown.h1',
                'desc1': 'timer.online-countdown.desc.1'
            }} />
            <MultiLanguageRoute path='/classroom-online-timer/:lang?' component={Timer} custom={{
                'title': 'timer.classroom-online-timer.seo.title',
                'description': 'timer.classroom-online-timer.seo.description',
                'h1': 'timer.classroom-online-timer.h1',
                'desc1': 'timer.classroom-online-timer.desc.1'
            }} />
            <MultiLanguageRoute path='/timer-for-kids/:lang?' component={Timer} custom={{
                'title': 'timer.timer-for-kids.seo.title',
                'description': 'timer.timer-for-kids.seo.description',
                'h1': 'timer.timer-for-kids.h1',
                'desc1': 'timer.timer-for-kids.desc.1'
            }} />
            <MultiLanguageRoute path='/tomato-timer/:lang?' component={PomodoroTimer} custom={{
                'title': 'pomodoroTimer.tomato-timer.seo.title',
                'description': 'pomodoroTimer.tomato-timer.seo.description',
                'h1': 'pomodoroTimer.tomato-timer.h1',
                'desc1': 'pomodoroTimer.tomato-timer.desc.1'
            }} />            
            <MultiLanguageRoute path='/bomb-timer/:lang?' component={BombTimer} />
            <MultiLanguageRoute path='/rocket-timer/:lang?' component={RocketTimer} />
            <MultiLanguageRoute path='/date-calculator/:lang?' component={DateCalculator} />
            <MultiLanguageRoute path='/clock/:lang?' component={Clock} />
            <MultiLanguageRoute path='/dino-game/:lang?' component={Dino} />
            <MultiLanguageRoute path='/tic-tac-toe/:lang?' component={TicTacToe} />
            <MultiLanguageRoute path='/math-bingo/:lang?' component={MathBingo} />
            <Route path='/mathgrid-bingo/:lang?' render={({ match, location }) => <Redirect to={`/math-bingo${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <Route path='/classroom-math-bingo/:lang?' render={({ match, location }) => <Redirect to={`/math-bingo${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <Route path='/kids-math-bingo/:lang?' render={({ match, location }) => <Redirect to={`/math-bingo${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <MultiLanguageRoute path='/adventure-runner/:lang?' component={AdventureRunner} />
            <MultiLanguageRoute path='/math-wizard/:lang?' component={MathWizard} />
            <Route path='/math-rpg/:lang?' render={({ match, location }) => <Redirect to={`/math-wizard${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <Route path='/wizard-math/:lang?' render={({ match, location }) => <Redirect to={`/math-wizard${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <MultiLanguageRoute path='/digital-escape-room/:lang?' component={DigitalEscapeRoom} />
            <Route path='/escape-room/:lang?' render={({ match, location }) => <Redirect to={`/digital-escape-room${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <Route path='/escape-room-digital/:lang?' render={({ match, location }) => <Redirect to={`/digital-escape-room${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <Route path='/classroom-escape-room/:lang?' render={({ match, location }) => <Redirect to={`/digital-escape-room${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <MultiLanguageRoute path='/cat-timer/:lang?' component={CatTimer} />
            <MultiLanguageRoute path='/christmas-timer/:lang?' component={ChristmasTimer} />
            <MultiLanguageRoute path='/countdown-new-year/:lang?' component={CountDownNewYear} />
            <MultiLanguageRoute path='/monster-race/:lang?' component={MonsterRace} />
            <MultiLanguageRoute path='/rocket-race/:lang?' component={RocketRace} />
            <MultiLanguageRoute path='/running-race/:lang?' component={RunningRace} />
            <MultiLanguageRoute path='/swimming-race/:lang?' component={SwimmingRace} />
            <MultiLanguageRoute path='/dynamite-timer/:lang?' component={DynamiteTimer} />
            <MultiLanguageRoute path='/egg-timer/:lang?' component={EggTimer} />
            <MultiLanguageRoute path='/candle-timer/:lang?' component={CandleTimer} />
            <MultiLanguageRoute path='/visual-timer/:lang?' component={VisualTimer} />
            <Route path='/visual-classroom-timer/:lang?' render={({ match, location }) => <Redirect to={`/visual-timer${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <Route path='/kids-visual-timer/:lang?' render={({ match, location }) => <Redirect to={`/visual-timer${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <MultiLanguageRoute path='/bouncy-balls-noise-meter/:lang?' component={BouncyBallsTimer} />
            <Route path='/classroom-noise-meter/:lang?' render={({ match, location }) => <Redirect to={`/bouncy-balls-noise-meter${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <Route path='/bouncy-balls/:lang?' render={({ match, location }) => <Redirect to={`/bouncy-balls-noise-meter${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <MultiLanguageRoute path='/pacman-timer/:lang?' component={PacmanTimer} />
            <MultiLanguageRoute path='/snail-race/:lang?' component={SnailRace} />
            <Route path='/snail-racing/:lang?' render={({ match, location }) => <Redirect to={`/snail-race${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <MultiLanguageRoute path='/duck-race/:lang?' component={DuckRace} />
            <Route path='/duck-racing/:lang?' render={({ match, location }) => <Redirect to={`/duck-race${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <MultiLanguageRoute path='/horse-race/:lang?' component={HorseRace} />
            <Route path='/horse-racing/:lang?' render={({ match, location }) => <Redirect to={`/horse-race${match.params.lang ? `/${match.params.lang}` : ''}${location.search || ''}`} />} />
            <MultiLanguageRoute path='/exam-timer/:lang?' component={ExamTimer} />
            <MultiLanguageRoute path='/sat-timer/:lang?' component={ExamTimer} custom={{ examId: 'sat' }} />
            <MultiLanguageRoute path='/act-timer/:lang?' component={ExamTimer} custom={{ examId: 'act' }} />
            <MultiLanguageRoute path='/lsat-timer/:lang?' component={ExamTimer} custom={{ examId: 'lsat' }} />
            <MultiLanguageRoute path='/mcat-timer/:lang?' component={ExamTimer} custom={{ examId: 'mcat' }} />
            <MultiLanguageRoute path='/gmat-timer/:lang?' component={ExamTimer} custom={{ examId: 'gmat' }} />
            <MultiLanguageRoute path='/gre-timer/:lang?' component={ExamTimer} custom={{ examId: 'gre' }} />
            <MultiLanguageRoute path='/bar-exam-timer/:lang?' component={ExamTimer} custom={{ examId: 'bar' }} />
            <MultiLanguageRoute path='/aws-timer/:lang?' component={ExamTimer} custom={{ examId: 'aws' }} />
            <MultiLanguageRoute path='/enem-timer/:lang?' component={ExamTimer} custom={{ examId: 'enem' }} />
            <MultiLanguageRoute path='/concursos-timer/:lang?' component={ExamTimer} custom={{ examId: 'concursos' }} />
            <MultiLanguageRoute path='/gamificacao-na-educacao-stem/:lang?' component={StemGamification} />
            <MultiLanguageRoute path='/stem-gamification-in-education/:lang?' component={StemGamification} />
            <MultiLanguageRoute path='/:lang' component={Stopwatch} />
            <Route component={NotFound} />
        </Switch>
    </React.Fragment>
)


export default router